import { createContext, useContext } from "react";

export interface PageContextType {
    body?: string;
    title?: string;
    siteId?: string;
    themeSettings?: {
        primaryColor?: string;
        secondaryColor?: string;
        backgroundColor?: string;
        textColor?: string;
        fontFamily?: string;
        [key: string]: any;
    };
    [key: string]: any;
}

export const PageContext = createContext<PageContextType>({});

export const usePageContext = () => useContext(PageContext);
